import { Box, Stack, ThemeProvider } from '@mui/system'
import NavBar from "./components/navbar"
import theme from './styles/theme'
import SideBar from './components/sidebar'
import Feed from './components/feed'
import RightBar from './components/rightbar'
import { Fragment, useEffect, useRef, useState, useCallback } from 'react'
import { DOMAIN } from './config'
import { parameter, parseTimestamp, parseStartAppParam } from './funcs'
import { UserProvider, useUser } from './contexts/userContext'
import PhotoDialog from './components/appDialog/PhotoDialog'
import { useMediaQuery } from "@mui/material"
import { FollowProvider } from './contexts/followContext'
import ChaportWidget from './components/chaport/chaportWidget'


function AppContent() {
  const matches = useMediaQuery(theme.breakpoints.down("md"))
  const [latestItems, setLatestItems] = useState(null)
  const { setUserData } = useUser()


  // PhotoDialog 展开状态
  const [photoDialogOpen, setPhotoDialogOpen] = useState(false)

  /** ✅ 包装 setUserData，加入 miniapp 判断 */
  const setUserDataWithMiniapp = useCallback((data) => {
    const isMiniapp =
      window.Telegram &&
      window.Telegram.WebApp &&
      Object.keys(window.Telegram.WebApp.initDataUnsafe || {}).length > 0
    const finalData = {
      ...data,
      miniapp: isMiniapp ? true : false,
    }
    setUserData(finalData)
  }, [setUserData])

  /** ✅ 处理 Telegram 用户信息 */
  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.ready()
      const tel_user = window.Telegram.WebApp.initDataUnsafe || {}
      if (Object.keys(tel_user).length === 0) return

      const param = parseStartAppParam(tel_user)
      let url = `${DOMAIN}ywyminiappbot/getUser?userid=${tel_user.user.id}`
      if (param?.agent) {
        url += `&agent=${param.agent}`
      } else {
        url += `&agent=2594848900`
      }



      fetch(url)
        .then(res => res.json())
        .then(data => setUserDataWithMiniapp(data))
        .catch(err => console.error("请求失败:", err))

      // ✅ 如果 param 中有 photo，自动打开 PhotoDialog
      if (param && param.photo) {
        setPhotoDialogOpen(true)
      }

      if (param?.shareuser) {
        console.log(param.shareuser)
        console.log(`${DOMAIN}lukcy/shareuserid?shareid=${param.shareuser}&userid=${tel_user.user.id}`)


        const timer = setTimeout(() => {
          fetch(`${DOMAIN}lukcy/shareuserin?shareid=${param.shareuser}&userid=${tel_user.user.id}`)
            .then(res => res.json())
            .then(data => {
              
            }).catch(console.error)
        }, 5000)

        return () => clearTimeout(timer)


      }
    } else {
      // 非 miniapp 情况下也设置 userData
      setUserDataWithMiniapp({})
    }
  }, [setUserDataWithMiniapp])

  /** ✅ 获取 VIP 状态 */
  useEffect(() => {
    fetch(`${DOMAIN}ywyminiappbot/getcookie`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (data.state === true) {
          const vipTime = parseTimestamp(data.timestart + data.days * 86400)
          data.expire = vipTime
          setUserDataWithMiniapp(data)
        }
      })
      .catch(console.error)
  }, [setUserDataWithMiniapp])

  /** ✅ 初始化加载第一页数据（只加载一次） */
  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${DOMAIN}ywyminiappbot/getLatest?page=1`)
        const data = await response.json()
        setLatestItems(data)
      } catch (error) {
        console.error("初始化数据失败:", error)
      }
    })()

    // ✅ 处理 URL 参数中的 aid
    const searchParams = new URLSearchParams(window.location.search)
    const aid = searchParams.get('aid')
    if (aid) {
      fetch(`${DOMAIN}ywyminiappbot/setAidCookie?aid=${aid}`, { credentials: 'include' })
        .then(res => res.json())
        .catch(console.error)
    }
  }, [])

  /** ✅ 过滤器逻辑 */
  const [filterResult, setFilterResult] = useState({
    sort: "最新发布",
    categories: [],
  })

  const [reset, setReset] = useState(false)
  const handleFilterChange = (newFilter) => {
    setFilterResult(newFilter)
    const filterStr = `filter+${encodeURIComponent(JSON.stringify(newFilter))}`
    setReset(filterStr)
  }
  

  /** ✅ 计算 Feed 的 fetchUrl */
  const getFeedUrl = useCallback(() => {
    const baseUrl = `${DOMAIN}ywyminiappbot/getLatest`
    const params = new URLSearchParams()

    params.append("sort", filterResult?.sort || "最新发布")
    if (filterResult?.categories?.length > 0) {
      params.append("categories", filterResult.categories.join(","))
    }

    return `${baseUrl}?${params.toString()}`
  }, [filterResult])



  return (
    <Fragment>
      <PhotoDialog open={photoDialogOpen} onClose={() => setPhotoDialogOpen(false)} />
      <NavBar matches={matches} handleFilterChange={handleFilterChange} />

      <Stack
        direction="row"
        sx={{
          position: "relative",
          height: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        {!matches && <SideBar />}

        {/* ✅ Feed 只加载第一页数据，滚动交给 Feed 内部 */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pt: "50px",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Feed
            matches={matches}
            latest={latestItems || []}
            setLatest={setLatestItems}
            fetchUrl={getFeedUrl()}
            reset={reset}
          />
        </Box>

        {!matches && <RightBar matches={matches} />}
      </Stack>
    </Fragment>
  )
}


function App() {
  return (
    <ThemeProvider theme={theme}>
      <UserProvider>
        <FollowProvider>
          <AppContent />
          <ChaportWidget />
        </FollowProvider>
      </UserProvider>
    </ThemeProvider>
  )
}


export default App
